import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '@core/navigation/navigation.service';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

    const authService = inject(AuthService);
    const navigationService = inject(NavigationService);
    const _router = inject(Router);
    const _confirm = inject(FuseConfirmationService);

    let newReq = req.clone();

    const token = authService.accessToken;

    // Request
    if (
        AuthUtils.isValidJwt(token) &&
        !AuthUtils.isTokenExpired(token)
    ) {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + token),
        });

        if (
            _router.url !== '/' &&
            _router.url !== '/seleccion-roles' &&
            !navigationService.isMenuLoaded
        ) {
            navigationService.getMenus();
        }
    }

    const mostrarDialogoError = (error: HttpErrorResponse) => {

        const descripcion = error.error?.result?.descripcion || 'Ocurrió un error desconocido.';
        const errores = error.error?.result?.errores || {};

        let mensajeError = `${error.message}\n${descripcion}`;

        for (const [campo, mensajes] of Object.entries(errores)) {
            if (Array.isArray(mensajes)) {
                mensajeError += `\n${campo}: ${mensajes.join(', ')}`;
            }
        }

        _confirm.open({
            title: `${error.name} ${error.status}` || 'Error',
            message: mensajeError,
            dismissible: false,
            actions: {
                confirm: {
                    show: true,
                    color: 'warn',
                    label: 'Confirmar'
                },
                cancel: {
                    show: false
                }
            }
        });
    };

    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {

            if (error.status === 0) {
                mostrarDialogoError(error);
                return throwError(() => new Error('Sin conexión o token inválido'));
            }

            if (error.status === 401) {
                authService.signOut();
                navigationService.isMenuLoaded = false;
                location.reload();
                return throwError(() => new Error('No autorizado'));
            }

            if (error.status === 500) {
                mostrarDialogoError(error);
                return throwError(() => new Error('Error interno del servidor'));
            }

            if (error.status === 404) {
                return throwError(() => new Error('Recurso no encontrado'));
            }

            mostrarDialogoError(error);
            return throwError(() => new Error('Error desconocido'));
        })
    );
};
